import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class PusherService {
	pusher: any;
	channel: any;
    journeyXOrderChannel: any;
    journeyOrderChannel: any;

	restaurantChannel: any;
	private restaurantChannelName: string;

	// pusher-js sai do vendor eager (Lever 1): o SDK (~170KB) só era usado no
	// rastreio/success do pedido, mas o import estático o arrastava para o boot
	// de TODA visita. Agora é import() dinâmico — baixado e instanciado só na
	// primeira assinatura de canal. A promise é memoizada p/ criar UMA conexão.
	private pusherPromise: Promise<any> | null = null;

	private ensurePusher(): Promise<any> {
		if (this.pusher) return Promise.resolve(this.pusher);
		if (!this.pusherPromise) {
			this.pusherPromise = import('pusher-js').then(({ default: Pusher }) => {
				Pusher.logToConsole = true;
				this.pusher = new Pusher(environment.pusher.key, {
					cluster: environment.pusher.cluster,
					forceTLS: true,
				});
				return this.pusher;
			});
		}
		return this.pusherPromise;
	}

	async subscribe(orderID: string) {
		const pusher = await this.ensurePusher();
		this.channel = pusher.subscribe(`order.${orderID}`);
        this.journeyXOrderChannel = pusher.subscribe(
            `journey.order.${orderID}`
        );
	}

    async subscribeJourneyOrder(journeyOrderID: string) {
        const pusher = await this.ensurePusher();
        this.journeyOrderChannel = pusher.subscribe(
            `journeyOrder.${journeyOrderID}`
        );
    }

	async subscribeRestaurant(restaurantID: string) {
		const pusher = await this.ensurePusher();
		this.restaurantChannelName = `order.restaurant.${restaurantID}`;
		this.restaurantChannel = pusher.subscribe(this.restaurantChannelName);
		return this.restaurantChannel;
	}

	unsubscribeRestaurant() {
		if (!this.restaurantChannelName || !this.pusher) return;
		this.pusher.unsubscribe(this.restaurantChannelName);
		this.restaurantChannel = null;
		this.restaurantChannelName = null;
	}
}
